import IHavainnotUser from "../../interfaces/IHavainnotUser";

export const requestLogin = "REQUEST_LOGIN";
export const setLanguage = "SET_LANGUAGE";


export const requestInitializeLogin = "REQUEST_INITIALIZE_LOGIN";
const successLogin = "SUCCESS_LOGIN";
const successGateLogin = "SUCCESS_GATE_LOGIN";
export const successAnonLogin = "SUCCESS_ANON_LOGIN";

const failureLogin = "FAILURE_LOGIN";
export const logout = "LOGOUT";


export const requestUsersAppRoles = "REQUEST_FETCH_USERS_APP_ROLES";
const successFetchUsersAppRoles = "SUCCESS_FETCH_USERS_APP_ROLES";
const failureFetchUsersAppRoles = "FAILURE_FETCH_USERS_APP_ROLES";
export const setUserAppRoles = "SET_APP_ROLES";

// TYPES
export interface IRequestLogin {
    type: typeof requestLogin;
    payload: {
        username: string;
        password: string;
    };
}

export interface ISetLanguage {
    type: typeof setLanguage;
    payload: {
        language: string;
    };
}


interface ISuccessLogin {
    type: typeof successLogin;
    payload: {
        sid: string;
        user: IHavainnotUser;
        returnHref: string;
        lang: string;
    };
}

interface ISuccessGateLogin {
    type: typeof successGateLogin;
    payload: {
        sid: string;
        user: IHavainnotUser;
        returnHref: string;
        lang: string;
        rdr: string;
    };
}

interface ISuccessAnonLogin {
    type: typeof successAnonLogin;
    payload: {
        sid: string;
        data: any;
    };
}


interface IFailureLogin {
    type: typeof failureLogin;
    error: Error;
}

interface IRequestInitializeLogin {
    type: typeof requestInitializeLogin;
}

interface ILogout {
    type: typeof logout;
}


export type TAuthAction
    = IRequestLogin
    | ISuccessGateLogin
    | ISuccessLogin
    | IFailureLogin
    | IRequestInitializeLogin
    | ILogout

    | ISuccessAnonLogin

    | IRequestFetchUsersAppRoles
    | ISuccessFetchUsersAppRoles
    | IFailureFetchUsersAppRoles
    | ISetUserAppRoles
    | ISetLanguage
    ;

// CREATORS
export const createRequestLoginAction = (username: string, password: string): IRequestLogin => ({
    type: requestLogin,
    payload: { username, password },
});

export const createRequestInitializeLoginAction = (): IRequestInitializeLogin => ({
    type: requestInitializeLogin,
});

export const createSetLanguageAction = (language: string): ISetLanguage => ({
    type: setLanguage,
    payload: { language }
});

export const createSuccessLoginAction = (sid: string, user: IHavainnotUser, returnHref: string, lang: string): ISuccessLogin => ({
    type: successLogin,
    payload: { sid, user, returnHref, lang },
});

export const createSuccessGateLoginAction = (sid: string, user: IHavainnotUser, returnHref: string, lang: string, rdr: string): ISuccessGateLogin => ({
    type: successGateLogin,
    payload: { sid, user, returnHref, lang, rdr },
});

export const createSuccessAnonLoginAction = (sid: string, data: any): ISuccessAnonLogin => ({
    type: successAnonLogin,
    payload: { sid, data },
});


export const createFailureLoginAction = (error: Error): IFailureLogin => ({
    type: failureLogin,
    error,
});

export const createLogoutAction = (): ILogout => ({
    type: logout,
});


export interface IRequestFetchUsersAppRoles {
    type: typeof requestUsersAppRoles;
}

interface ISuccessFetchUsersAppRoles {
    type: typeof successFetchUsersAppRoles;
    payload: { roles: string[] };
}

interface IFailureFetchUsersAppRoles {
    type: typeof failureFetchUsersAppRoles;
    payload: { error: Error };
}

export interface ISetUserAppRoles {
    type: typeof setUserAppRoles;
    payload: { roles: string[] }
}


export const createRequestFetchUserAppRoles = (): IRequestFetchUsersAppRoles => ({
    type: requestUsersAppRoles,
});

export const createSuccessFetchUserAppRoles = (roles: string[]): ISuccessFetchUsersAppRoles => ({
    type: successFetchUsersAppRoles,
    payload: { roles },
});

export const createFailureFetchUserAppRoles = (error: Error): IFailureFetchUsersAppRoles => ({
    type: failureFetchUsersAppRoles,
    payload: { error },
});

export const createSetUserAppRolesAction = (roles: string[]): ISetUserAppRoles => ({
    type: setUserAppRoles,
    payload: { roles },
});



